import { Capacitor } from "@capacitor/core";
import { hasTelegramLaunchContext } from "./telegram.js";

export function currentAppSurface() {
  if (hasTelegramLaunchContext()) return "telegram";
  const platform = Capacitor.getPlatform();
  return ["android", "ios"].includes(platform) ? platform : "web";
}
